export default `/* Ids Toolbar More Actions Component */
:host {
  display: inline-flex;
}

:host([hidden]) {
  display: none;
}

:host(:not([no-padding])), .more:not([no-padding]) {
  margin-inline-start: 2px;
  margin-inline-end: 2px;
}

::slotted(ids-separator) {
  align-self: center;
  justify-self: center;
}

.ids-toolbar-more-actions {
  padding-inline-end: 1px;
  white-space: nowrap;
  width: auto;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtdG9vbGJhciIsInNvdXJjZXMiOlsiaWRzLXRvb2xiYXItbW9yZS1hY3Rpb25zLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7QUFFQTtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyIvKiBJZHMgVG9vbGJhciBNb3JlIEFjdGlvbnMgQ29tcG9uZW50ICovXG5cbjpob3N0IHtcbiAgZGlzcGxheTogaW5saW5lLWZsZXg7XG59XG5cbjpob3N0KFtoaWRkZW5dKSB7XG4gIGRpc3BsYXk6IG5vbmU7XG59XG5cbjpob3N0KDpub3QoW25vLXBhZGRpbmddKSksIC5tb3JlOm5vdChbbm8tcGFkZGluZ10pIHtcbiAgbWFyZ2luLWlubGluZS1zdGFydDogMnB4O1xuICBtYXJnaW4taW5saW5lLWVuZDogMnB4O1xufVxuXG46OnNsb3R0ZWQoaWRzLXNlcGFyYXRvcikge1xuICBhbGlnbi1zZWxmOiBjZW50ZXI7XG4gIGp1c3RpZnktc2VsZjogY2VudGVyO1xufVxuXG4uaWRzLXRvb2xiYXItbW9yZS1hY3Rpb25zIHtcbiAgcGFkZGluZy1pbmxpbmUtZW5kOiAxcHg7XG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gIHdpZHRoOiBhdXRvO1xufVxuIl19 */`;
